// ADA Fix: Add aria-label to Stamped.io star rating badge
function setStampedAriaLabel(badge) {
  var ratingEl = badge.querySelector('[data-rating]')
               || badge.querySelector('.stamped-summary-starrating');
  var countEl = badge.querySelector('.stamped-badge-caption[data-reviews]')
              || badge.querySelector('.stamped-summary-reviews-count')
              || badge.querySelector('[data-count]');

  var rating = ratingEl ? (ratingEl.getAttribute('data-rating') || ratingEl.textContent.trim()) : null;
  var count = countEl ? (countEl.getAttribute('data-reviews') || countEl.textContent.replace(/[^0-9]/g, '')) : null;

  if (rating && count && count !== '') {
    badge.setAttribute('aria-label', rating + ' out of 5 stars, ' + count + ' reviews');
  } else if (rating) {
    badge.setAttribute('aria-label', rating + ' out of 5 stars');
  }
}

var stampedObserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    mutation.addedNodes.forEach(function(node) {
      if (node.nodeType === 1) {
        var badges = node.querySelectorAll ? node.querySelectorAll('.stamped-product-reviews-badge') : [];
        if (node.classList && node.classList.contains('stamped-product-reviews-badge')) {
          setStampedAriaLabel(node);
        }
        badges.forEach(function(badge) { setStampedAriaLabel(badge); });
      }
    });
  });
});

stampedObserver.observe(document.body, { childList: true, subtree: true });

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.stamped-product-reviews-badge').forEach(function(badge) {
    setTimeout(function() { setStampedAriaLabel(badge); }, 2000);
  });
});